export default "__VITE_ASSET__BUqF9A2g__"